module.exports = __webpack_public_path__ + "img/cart-empty.bf81816c.png";